import {
  NEWS_LOADING,
  NEWS_ERROR,

  NEWS_GET_LIST,
  NEWS_GET_FILTERS,
  NEWS_GET_SINGLE,
  NEWS_CREATE,
  NEWS_GET_TYPES
} from "actions/news/constants";

const initialState = {
  loading: false,
  errors: [],

  list: [],
  filters: [],
  single: {},

  types: []
};

export default function (state = initialState, action) {
  let list = [],
    single = {},
    index;
  switch (action.type) {
    case NEWS_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case NEWS_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case NEWS_GET_LIST:
      return {
        ...state,
        errors: [],
        loading: false,
        list: action.payload,
      };
    case NEWS_GET_FILTERS:
      return {
        ...state,
        errors: [],
        loading: false,
        tagFilters: action.payload.content,
      };
    case NEWS_GET_SINGLE:
      return {
        ...state,
        errors: [],
        loading: false,
        single: action.payload,
      };
    case NEWS_CREATE:
      list = [...state.list];
      index = list.findIndex(item => item.id === action.payload.content.id);
      if (index > -1) {
        list[index] = action.payload.content;
      } else {
        list.push(action.payload.content);
      }

      single = Object.assign({}, state.single);
      if (single.id === action.payload.content.id) {
        single = action.payload.content;
      }

      return {
        ...state,
        errors: [],
        loading: false,
        list,
        single
      };
    case NEWS_GET_TYPES:
      return {
        ...state,
        errors: [],
        loading: false,
        types: action.payload.content
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/newsReducer.js